(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SVGNS = 'http://www.w3.org/2000/svg';

  /* ---------- Aparición al hacer scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.nv-reveal:not(.nv-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nv-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('nv-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax suave ---------- */
  function initParallax() {
    var els = document.querySelectorAll('[data-nv-parallax]');
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      els.forEach(function (h) {
        var r = h.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var k = parseFloat(h.getAttribute('data-nv-parallax')) || 0;
        h.style.setProperty('--nv-parallax', (-r.top * k / 100) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Cable con LEDs (decorativo y demo de modos) ---------- */
  function dibujarCable(contenedor, n, caida, claseLed) {
    var W = 1000, H = 100;
    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    function y(x) { var t = x / W - 0.5; return 8 + (caida - 8) * (1 - 4 * t * t); }
    var d = 'M0 ' + y(0);
    for (var x = 20; x <= W; x += 20) d += ' L' + x + ' ' + y(x).toFixed(1);
    var path = document.createElementNS(SVGNS, 'path');
    path.setAttribute('d', d);
    path.setAttribute('vector-effect', 'non-scaling-stroke');
    svg.appendChild(path);
    contenedor.appendChild(svg);
    var leds = [];
    for (var i = 0; i < n; i++) {
      var cx = (i + 0.5) * W / n;
      var led = document.createElement('span');
      led.className = 'nv-bombilla' + (claseLed ? ' ' + claseLed : '');
      led.style.left = (cx / W * 100).toFixed(2) + '%';
      led.style.top = ((y(cx) + 4) / H * 100).toFixed(2) + '%';
      led.style.setProperty('--d', (Math.random() * 2.8).toFixed(2) + 's');
      contenedor.appendChild(led);
      leds.push(led);
    }
    return leds;
  }

  function initGuirnaldas() {
    document.querySelectorAll('[data-nv-guirnalda]').forEach(function (el) {
      if (el.querySelector('svg')) return;
      var n = window.innerWidth < 750 ? 14 : 28;
      dibujarCable(el, n, parseFloat(el.getAttribute('data-nv-guirnalda')) || 60, 'nv-led');
    });
  }

  /* ---------- Demostración de los 8 modos ---------- */
  var EFECTOS = {
    fija: function (leds) { leds.forEach(function (l) { l.style.opacity = 1; }); },
    ondas: function (leds, t) { leds.forEach(function (l, i) { l.style.opacity = 0.2 + 0.8 * (0.5 + 0.5 * Math.sin(t / 260 - i * 0.55)); }); },
    secuencial: function (leds, t) { var f = Math.floor(t / 520) % 2; leds.forEach(function (l, i) { l.style.opacity = (i % 2 === f) ? 1 : 0.12; }); },
    brillo_lento: function (leds, t) { var v = 0.15 + 0.85 * (0.5 + 0.5 * Math.sin(t / 900)); leds.forEach(function (l) { l.style.opacity = v; }); },
    persecucion: function (leds, t) { var p = Math.floor(t / 90) % leds.length; leds.forEach(function (l, i) { var d = (p - i + leds.length) % leds.length; l.style.opacity = d < 4 ? 1 - d * 0.22 : 0.12; }); },
    desvanecido: function (leds, t) { var a = 0.5 + 0.5 * Math.sin(t / 700); leds.forEach(function (l, i) { l.style.opacity = 0.12 + 0.88 * (i % 2 ? a : 1 - a); }); },
    destellos: function (leds, t, st) {
      if (!st.ultimo || t - st.ultimo > 110) {
        st.ultimo = t;
        leds.forEach(function (l) { l.style.opacity = Math.random() > 0.55 ? 1 : 0.15; });
      }
    },
    combinacion: function (leds, t, st) {
      var orden = ['ondas', 'secuencial', 'brillo_lento', 'persecucion', 'desvanecido', 'destellos', 'fija'];
      EFECTOS[orden[Math.floor(t / 2600) % orden.length]](leds, t, st);
    }
  };

  function initModos() {
    document.querySelectorAll('[data-nv-modos]').forEach(function (root) {
      var cable = root.querySelector('[data-nv-modos-cable]');
      if (!cable || cable.querySelector('svg')) return;
      var leds = dibujarCable(cable, window.innerWidth < 750 ? 18 : 30, 70, '');
      var actual = root.querySelector('[data-nv-modos-actual]');
      var botones = root.querySelectorAll('[data-nv-efecto]');
      var efecto = 'fija', estado = {}, visible = false;
      function elegir(btn) {
        botones.forEach(function (b) { b.classList.remove('is-activo'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-activo'); btn.setAttribute('aria-pressed', 'true');
        efecto = btn.getAttribute('data-nv-efecto'); estado = {};
        if (actual) actual.textContent = btn.getAttribute('data-nombre') || '';
        if (reduce) EFECTOS.fija(leds);
      }
      botones.forEach(function (b) { b.addEventListener('click', function () { elegir(b); }); });
      if (botones[0]) elegir(botones[0]);
      if (reduce) return;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(root);
      } else { visible = true; }
      function bucle(t) {
        if (visible && EFECTOS[efecto]) EFECTOS[efecto](leds, t, estado);
        requestAnimationFrame(bucle);
      }
      requestAnimationFrame(bucle);
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto() {
    document.querySelectorAll('[data-nv-producto]').forEach(function (root) {
      // Galería
      var principal = root.querySelector('[data-nv-principal]');
      root.querySelectorAll('[data-nv-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!principal) return;
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = btn.getAttribute('data-src');
            principal.srcset = btn.getAttribute('data-srcset') || '';
            principal.alt = btn.getAttribute('data-alt') || '';
            principal.style.opacity = '1';
          }, 180);
          root.querySelectorAll('[data-nv-mini]').forEach(function (b) { b.classList.remove('is-activa'); });
          btn.classList.add('is-activa');
        });
      });

      // Ofertas por cantidad → fija la cantidad que usa el formulario de pago contra entrega
      var ofertas = root.querySelectorAll('[data-nv-oferta]');
      function fijarCantidad(q) {
        document.querySelectorAll('form[action*="/cart/add"] input[name="quantity"]').forEach(function (inp) {
          inp.value = q;
          inp.dispatchEvent(new Event('input', { bubbles: true }));
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      ofertas.forEach(function (o) {
        var radio = o.querySelector('input');
        radio.addEventListener('change', function () {
          ofertas.forEach(function (x) { x.classList.toggle('is-activa', x === o); });
          fijarCantidad(o.getAttribute('data-cantidad'));
          var precio = o.getAttribute('data-precio');
          document.querySelectorAll('[data-nv-barra-precio]').forEach(function (el) { el.textContent = precio; });
        });
      });
      var marcada = root.querySelector('[data-nv-oferta] input:checked');
      if (marcada) fijarCantidad(marcada.closest('[data-nv-oferta]').getAttribute('data-cantidad'));
    });

    // Barra fija: aparece al pasar la zona de compra
    var barra = document.querySelector('[data-nv-barra]');
    var zona = document.querySelector('[data-nv-zona-compra]');
    if (barra && zona && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        var pasada = !e.isIntersecting && e.boundingClientRect.top < 0;
        barra.classList.toggle('is-visible', pasada);
        barra.setAttribute('aria-hidden', pasada ? 'false' : 'true');
      }).observe(zona);
      var btn = barra.querySelector('button');
      if (btn) btn.addEventListener('click', function () {
        zona.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    }
  }

  function init() { initReveal(); initParallax(); initGuirnaldas(); initModos(); initProducto(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initReveal(); initGuirnaldas(); initModos(); initProducto(); });
})();
